<template>
  <div class="h-full flex flex-col inset-0 bg-gradient-to-r from-green-200/50 via-blue-100/30 to-blue-200/30">
    <div class="flex-1 overflow-y-auto">
      <div class="relative p-3 sm:p-6 h-full flex flex-col">
        <!-- Added flex flex-col -->
        <div class="relative z-10 flex flex-col flex-1">
          <!-- Added flex-1 -->
          <!-- Header section -->
          <div class="flex flex-col items-center w-full">
            <div class="flex flex-col items-center">
              <div class="text-2xl sm:text-3xl font-bold text-gray-800">You're all set</div>
              <p class="text-gray-500 text-sm mt-2 max-w-lg text-center">
                We've saved your information and {{ company.name }} has been notified.
                <!-- TODO: do we need this line below? -->
                <!-- TODO: You'll receive a confirmation
                email shortly. -->
              </p>
            </div>
          </div>

          <div class="flex items-center text-gray-600 text-xs text-center my-4 sm:my-6 max-w-xl mx-auto w-full">
            <div class="flex-grow border-t border-gray-300 mr-2"></div>
            Introducing your secure portal
            <div class="flex-grow border-t border-gray-300 ml-2"></div>
          </div>

          <div class="sm:mt-3 flex justify-center relative z-10">
            <div class="max-w-xl w-full">
              <div class="grid grid-cols-1 gap-1 sm:grid-cols-2 sm:grid-rows-2 sm:gap-4 text-sm sm:text-xs md:text-sm">
                <div
                  class="flex items-center gap-2"
                  v-for="(feature, i) in portalFeatures"
                  :key="i"
                >
                  <div class="flex items-center justify-center rounded-full bg-primary-600 w-4 h-4 sm:w-6 sm:h-6">
                    <ion-icon
                      name="checkmark-outline"
                      class="text-white text-xs"
                    ></ion-icon>
                  </div>
                  {{ feature }}
                </div>
              </div>
            </div>
          </div>

          <div class="w-full max-w-xl mx-auto mt-6 flex justify-center">
            <div class="relative w-[500px] h-[180px] sm:w-[576px] sm:h-[250px] bg-white shadow-sm">
              <iframe
                src="https://www.loom.com/embed/b9d21a672377485e869749a0f2c1ce07?sid=adaeda3a-f4ba-43b7-8352-5b80ff8e1444"
                class="w-full h-full"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              ></iframe>
            </div>
          </div>
          <!-- Button section with mt-auto for mobile -->
          <div class="flex items-center justify-center gap-4 relative z-10 sm:mt-5 mt-auto">
            <portal-button-link
              color="primary"
              class="flex items-center justify-center w-full sm:w-56"
              :href="portalLoginLink"
            >
              <span class="font-bold">Explore your portal</span>
              <ion-icon
                name="chevron-forward-outline"
                class="text-xl"
              ></ion-icon>
            </portal-button-link>
            <portal-button-link
              color="primary-bordered-transparent"
              @click.prevent=""
              class="items-center justify-center w-56 gap-1 font-bold hidden sm:flex"
              href=""
            >
              <ion-icon
                name="play-circle-outline"
                class="text-xl"
              ></ion-icon>
              <span class="font-bold">Watch tutorial videos</span>
            </portal-button-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PortalButtonLink from "../../../ClientPortal/UI/PortalButtons/PortalButtonLink.vue"

export default {
  name: "PortalBillingProposalComplete",
  components: { PortalButtonLink },
  data() {
    return {
      company: window.FinancialCents.company,
      portalFeatures: [
        "Secure passwordless portal",
        "Communicate with your accountant",
        "Send and receive documents",
        "View all proposals, invoices & more",
      ],
    }
  },
  computed: {
    portalLoginLink() {
      let customUri = window.FinancialCents.company.firm_custom_uri
      return customUri
        ? `${window.location.origin}/cp/${window.FinancialCents.company.firm_custom_uri}`
        : `${window.location.origin}/cp`
    },
  },
}
</script>
